// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","reviewsSection":"ReviewsSection_reviewsSection__F8MdB"};